export const en = {
    'about-price': 'Learn more about prices in ads',
    'editor-cancel-action': 'Cancel',
    'editor-clear-fields-action': 'Clear fields',
    'editor-save-action': 'Save',
    'price-hint-text':
        "Enter the price so that your item can be featured in the product gallery. Don't forget to upload images. {helpUrl}"
};
